import React, { useEffect, useState } from 'react'
import Header from "../../../layout/header";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";

const UCDView = ({
    ucdById,
    ucdDetails = [],
    match,
}) => {
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await ucdById(match?.params?.id)
            setIsLoading(false)
        })()
    }, [])

    const getExtension = (filename) => {
        return filename.split('.').pop()
    }


    return (
        <>
            <Loader isLoading={isLoading} />
            <div id="wrapper">
                <DashboardMenu />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'UCD Dealer'}
                        />
                        {/*BODY*/}
                        <div className="container-fluid">
                            {/*Heading*/}
                            <div className="hide d-sm-flex align-items-center justify-content-between com-heading">
                                <h1 className="h3 mb-0 text-black-100">View</h1>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="mb-0 bg-white">
                                        <div className="div-com-header">
                                        </div>
                                        <div className="card-body">
                                            <div className="user">
                                                <div className="form-group row">
                                                    {ucdDetails?.data && ucdDetails?.data?.channel_type &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                value={ucdDetails?.data?.channel_type}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Channel Type
                                                            </label>
                                                        </div>
                                                    }

                                                    {ucdDetails?.data && ucdDetails?.data?.organization_type &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                onChange={(e) => {
                                                                    // handlePocInput(e.target.value, 'city', i)
                                                                }}
                                                                value={ucdDetails?.data?.organization_type}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Organization Type
                                                            </label>
                                                        </div>
                                                    }
                                                    {ucdDetails?.data && ucdDetails?.data?.business_name &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                onChange={(e) => {
                                                                    // handlePocInput(e.target.value, 'city', i)
                                                                }}
                                                                value={ucdDetails?.data?.business_name}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Business Name
                                                            </label>
                                                        </div>
                                                    }
                                                    {ucdDetails?.data && ucdDetails?.data?.owner_name &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                onChange={(e) => {
                                                                    // handlePocInput(e.target.value, 'city', i)
                                                                }}
                                                                value={ucdDetails?.data?.owner_name}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Owner Name
                                                            </label>
                                                        </div>
                                                    }
                                                    {ucdDetails?.data && ucdDetails?.data?.firm_name &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                onChange={(e) => {
                                                                    // handlePocInput(e.target.value, 'city', i)
                                                                }}
                                                                value={ucdDetails?.data?.firm_name}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Firm Type
                                                            </label>
                                                        </div>
                                                    }
                                                    {ucdDetails?.data && ucdDetails?.data?.gst_registration &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                onChange={(e) => {
                                                                    // handlePocInput(e.target.value, 'city', i)
                                                                }}
                                                                value={ucdDetails?.data?.gst_registration}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Is GST Registration
                                                            </label>
                                                        </div>
                                                    }
                                                    {ucdDetails?.data && ucdDetails?.data?.dealer_gst_no &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                onChange={(e) => {
                                                                    // handlePocInput(e.target.value, 'city', i)
                                                                }}
                                                                value={ucdDetails?.data?.dealer_gst_no}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                GST No.
                                                            </label>
                                                        </div>
                                                    }
                                                    {ucdDetails?.data && ucdDetails?.data?.dealer_pan_no &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                value={ucdDetails?.data?.dealer_pan_no}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                PAN No.
                                                            </label>
                                                        </div>
                                                    }
                                                    {ucdDetails?.data && ucdDetails?.data?.aadhar_no &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                value={ucdDetails?.data?.aadhar_no}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Adhaar No.
                                                            </label>
                                                        </div>
                                                    }
                                                    {ucdDetails?.data && ucdDetails?.data?.registration_mobile_no &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                value={ucdDetails?.data?.registration_mobile_no}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Phone No.
                                                            </label>
                                                        </div>
                                                    }
                                                    {ucdDetails?.data && ucdDetails?.data?.registration_email &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                value={ucdDetails?.data?.registration_email}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Email
                                                            </label>
                                                        </div>
                                                    }
                                                    {ucdDetails?.data && ucdDetails?.data?.current_location &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                value={ucdDetails?.data?.current_location}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Registration Address
                                                            </label>
                                                        </div>
                                                    }
                                                    {ucdDetails?.data && ucdDetails?.data?.office_location &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                value={ucdDetails?.data?.office_location}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Office Address
                                                            </label>
                                                        </div>
                                                    }
                                                    {ucdDetails?.data && ucdDetails?.data?.bank_name &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                value={ucdDetails?.data?.bank_name}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Bank Name
                                                            </label>
                                                        </div>
                                                    }
                                                    {ucdDetails?.data && ucdDetails?.data?.account_no &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                value={ucdDetails?.data?.account_no}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Account No.
                                                            </label>
                                                        </div>
                                                    }
                                                    {ucdDetails?.data && ucdDetails?.data?.ifsc_code &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                value={ucdDetails?.data?.ifsc_code}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                IFSC Code
                                                            </label>
                                                        </div>
                                                    }
                                                    {ucdDetails?.data && ucdDetails?.data?.branch_name &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                value={ucdDetails?.data?.branch_name}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Branch Name
                                                            </label>
                                                        </div>
                                                    }
                                                    {ucdDetails?.data && ucdDetails?.data?.msme_no &&
                                                        <>
                                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    value={ucdDetails?.data?.msme_no}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    MSME No.
                                                                </label>
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                                {ucdDetails?.data && ucdDetails?.data?.upload_cancelled_cheque && (
                                                    <>
                                                        <div className="card">
                                                            <div
                                                                className="card-header"
                                                                style={{ backgroundColor: "#473381", color: "white" }}
                                                            >
                                                                Cancelled Cheque
                                                            </div>
                                                            <div className="card-body">
                                                                {getExtension(ucdDetails?.data?.upload_cancelled_cheque).toLowerCase() === "pdf" ? (
                                                                    <iframe
                                                                        src={`https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(
                                                                            ucdDetails.data.upload_cancelled_cheque.replace(/\\/g, '')
                                                                        )}`}
                                                                        width="100%"
                                                                        height="600px"
                                                                        style={{ border: "none" }}
                                                                        title="Cancelled Cheque PDF"
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        src={ucdDetails?.data?.upload_cancelled_cheque.replace(/\\/g, '')}
                                                                        style={{ maxWidth: "100%" }}
                                                                        alt="Cancelled Cheque"
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                                {ucdDetails?.data && ucdDetails?.data?.gst_certificate_photo && (
                                                    <>
                                                        <div className="card">
                                                            <div
                                                                className="card-header"
                                                                style={{ backgroundColor: "#473381", color: "white" }}
                                                            >
                                                                GST Certificate
                                                            </div>
                                                            <div className="card-body">
                                                                {getExtension(ucdDetails?.data?.gst_certificate_photo).toLowerCase() === "pdf" ? (
                                                                    <iframe
                                                                        src={`https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(
                                                                            ucdDetails.data.gst_certificate_photo
                                                                        )}`}
                                                                        width="100%"
                                                                        height="600px"
                                                                        style={{ border: "none" }}
                                                                        title="GST Certificate PDF"
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        src={ucdDetails?.data?.gst_certificate_photo}
                                                                        style={{ maxWidth: "100%" }}
                                                                        alt="GST Certificate"
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {ucdDetails?.data && ucdDetails?.data?.pan_card_photo && (
                                                    <>
                                                        <div className="card">
                                                            <div
                                                                className="card-header"
                                                                style={{ backgroundColor: "#473381", color: "white" }}
                                                            >
                                                                PAN Card
                                                            </div>
                                                            <div className="card-body">
                                                                {getExtension(ucdDetails?.data?.pan_card_photo).toLowerCase() === "pdf" ? (
                                                                    <iframe
                                                                        src={`https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(
                                                                            ucdDetails.data.pan_card_photo
                                                                        )}`}
                                                                        width="100%"
                                                                        height="600px"
                                                                        style={{ border: "none" }}
                                                                        title="PAN Card PDF"
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        src={ucdDetails?.data?.pan_card_photo}
                                                                        style={{ maxWidth: "100%" }}
                                                                        alt="PAN Card"
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {ucdDetails?.data && ucdDetails?.data?.msme_declaration_photo && (
                                                    <>
                                                        <div className="card">
                                                            <div
                                                                className="card-header"
                                                                style={{ backgroundColor: "#473381", color: "white" }}
                                                            >
                                                                MSME Declaration
                                                            </div>
                                                            <div className="card-body">
                                                                {getExtension(ucdDetails?.data?.msme_declaration_photo).toLowerCase() === "pdf" ? (
                                                                    <iframe
                                                                        src={`https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(
                                                                            ucdDetails.data.msme_declaration_photo
                                                                        )}`}
                                                                        width="100%"
                                                                        height="600px"
                                                                        style={{ border: "none" }}
                                                                        title="MSME Declaration PDF"
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        src={ucdDetails?.data?.msme_declaration_photo}
                                                                        style={{ maxWidth: "100%" }}
                                                                        alt="MSME Declaration"
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}














                                                {/*{ucdDetails?.data && ucdDetails?.data?.selfie_with_dsa &&*/}
                                                {/*    <>*/}
                                                {/*        <div className="card">*/}
                                                {/*            <div className="card-header" style={{ backgroundColor: "#473381", color: "white" }}>*/}
                                                {/*                Selfie With DSA*/}
                                                {/*            </div>*/}
                                                {/*            <div className="card-body">*/}
                                                {/*                {getExtension(ucdDetails?.data?.selfie_with_dsa).toLowerCase() === "pdf" ?*/}
                                                {/*                    <a href={ucdDetails?.data?.selfie_with_dsa} target="_blank">Selfie With DS</a>*/}
                                                {/*                    : <img*/}
                                                {/*                        src={ucdDetails?.data?.selfie_with_dsa}*/}
                                                {/*                        alt="document"/>*/}
                                                {/*                }*/}
                                                {/*            </div>*/}
                                                {/*        </div>*/}
                                                {/*    </>*/}
                                                {/*}*/}

                                                {ucdDetails?.data && ucdDetails?.data?.dealer_images && (
                                                    <>
                                                        <div className="card">
                                                            <div
                                                                className="card-header"
                                                                style={{ backgroundColor: "#473381", color: "white" }}
                                                            >
                                                                Dealer Images
                                                            </div>
                                                            {Object.keys(ucdDetails?.data?.dealer_images).length > 0 &&
                                                                ucdDetails?.data?.dealer_images.map((val, index) => {
                                                                    return (
                                                                        <div key={index}>
                                                                            {getExtension(val).toLowerCase() === "pdf" ? (
                                                                                <iframe
                                                                                    src={`https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(val)}`}
                                                                                    width="100%"
                                                                                    height="600px"
                                                                                    style={{ border: "none" }}
                                                                                    title={`Dealer Document PDF ${index + 1}`}
                                                                                />
                                                                            ) : (
                                                                                <img
                                                                                    src={val}
                                                                                    style={{ maxWidth: "100%" }}
                                                                                    alt={`Dealer Image ${index + 1}`}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                        </div>
                                                    </>
                                                )}


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UCDView;